import React from 'react';
import { get } from 'lodash';
import moment from 'moment';
import { useTimezone } from 'libs/hooks';
import { TMentoringClass } from 'modules/mentoring';
import { CDayOfWeek, CDefaultDateTimeFormat } from 'constants/base.const';
import { CMentoringClassStatusTag, CMentoringClassStatusValue } from 'constants/mentoring.const';
import { EMentoringClassStatus } from 'enums/mentoring.enum';
import { Tag } from 'antd';

const MentoringClassStatus = ({ record, id }: { record: TMentoringClass; id?: string }) => {
  const [getDateTime, timezone] = useTimezone();
  const value = getDateTime(get(record, 'start_at'));
  const today = getDateTime('');
  const formatString =
    value.minutes() > 0
      ? `MM월 DD일 ${get(CDayOfWeek, value.day())}, A h시 m분`
      : `MM월 DD일 ${get(CDayOfWeek, value.day())}, A h시`;
  // const remaining_days = Math.floor(get(record, "remaining_hours") / 24);
  const remaining_days = Math.ceil(get(record, 'remaining_hours') / 24);
  const remaining_hours = get(record, 'remaining_hours') % 24;
  const remaining_time =
    // remaining_days < 1 ? `${remaining_hours}시간` : `${remaining_days}일`;

    //24시간 이상으로 남았을 때는 날짜 차이로 표기 / 24시간 이하로 남았을 때는 시간으로 표기
    //시간까지 고려해서 남은 날짜 계산하는게 아니라, 오로지 날짜만으로 남은 날짜를 계산하기 위해
    get(record, 'remaining_hours') <= 24
      ? `${get(record, 'remaining_hours')}시간`
      : `${moment(value.format('YYYY-MM-DD')).diff(moment(today.format('YYYY-MM-DD')), 'days')}일`;

  const startTime = value
    .format(formatString)
    .replace('PM', '오후')
    .replace('AM', '오전')
    .includes('오전 12시')
    ? value
        .format(formatString)
        .replace('PM', '오후')
        .replace('AM', '오전')
        .replace('12시', '0시')
    : value
        .format(formatString)
        .replace('PM', '오후')
        .replace('AM', '오전');

  const makeRemainingTimeUntilAccept = () => {
    let createdAt;
    //일정 수정한 수업의 경우 get(record, "updated_at") 값이 string으로 들어올것이다
    if (get(record, 'updated_at')) {
      createdAt = getDateTime(get(record, 'updated_at'));
    } else {
      createdAt = getDateTime(get(record, 'created_at'));
    }

    // const createdAt = getDateTime(get(record, "created_at"));
    const startAt = getDateTime(get(record, 'start_at'));
    //신청 ~ 시작까지 남은 시간 (24시간 이내 여부 확인)
    const createdTimeToStartTime = moment(startAt.format(CDefaultDateTimeFormat)).diff(
      moment(today.format(CDefaultDateTimeFormat)),
      'hours',
    );

    if (createdTimeToStartTime >= 24) {
      //24시간 이상남았을 때 신청했을 경우 => 신청시간부터 24시간 이후까지 멘토 수락 가능
      const expirationTime = createdAt
        .clone()
        .add(24, 'h')
        .format(CDefaultDateTimeFormat);
      const timeRemainingUntilAccept = moment(expirationTime).diff(
        moment(today.format(CDefaultDateTimeFormat)),
        'hours',
      );
      // console.log("24시간 이상남음=> 24시간으로 세팅",timeRemainingUntilAccept)
      return timeRemainingUntilAccept;
    } else {
      //24시간 미만으로 남았을 때 신청했을 경우 => 수업시작시간부터 30분 전까지 멘토 수락 가능
      const expirationTime = startAt
        .clone()
        .subtract(30, 'm')
        .format(CDefaultDateTimeFormat);
      const timeRemainingUntilAccept = moment(expirationTime).diff(
        moment(today.format(CDefaultDateTimeFormat)),
        'hours',
      );
      // console.log("24시간 미만남음=> 시작 30분 전으로 세팅",timeRemainingUntilAccept)
      return timeRemainingUntilAccept;
    }
  };

  return (
    <>
      {(get(record, 'status') === EMentoringClassStatus.RequestPending ||
        get(record, 'status') === EMentoringClassStatus.RequestAccepted) &&
        get(record, 'remaining_hours') >= 0 && <Tag className='red-tag'>{remaining_time} 남음</Tag>}
      {CMentoringClassStatusValue[get(record, 'status')] && (
        <Tag className={CMentoringClassStatusTag[get(record, 'status')]}>
          {CMentoringClassStatusValue[get(record, 'status')]}
          {/* //status가 "request_pending"인경우에 한하여  */}
          {get(record, 'status') === 'request_pending' &&
            ` / 수락까지 ${makeRemainingTimeUntilAccept()}시간 남음`}
        </Tag>
      )}
      {get(record, 'status') === EMentoringClassStatus.Completed && (
        <>
          {get(record, 'is_mentor_attended') === false && <Tag className='red-tag'>멘토불참</Tag>}
          {get(record, 'is_mentee_attended') === false && <Tag className='red-tag'>멘티불참</Tag>}
        </>
      )}
      <div id={id} className='class-time'>
        <div style={{ display: 'inline-block', marginRight: '10px' }}>
          {/* //기존 오전 12시로 표기 */}
          {/* {value.format(formatString).replace("PM", "오후").replace("AM", "오전")} */}
          {/* //수정 오전 0시로 표기 */}
          {startTime}
        </div>
        <div style={{ display: 'inline-block' }}>
          <span style={{ fontSize: '13px', fontWeight: 'normal' }}>
            Timezone:&nbsp;<span style={{ color: '#aeaeae' }}>{timezone}</span>
          </span>
        </div>
      </div>
    </>
  );
};

export default MentoringClassStatus;
